import { Anchor, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Stack py="xl">
      <Title order={1}>{t("not_found.title")}</Title>
      <Anchor component={Link} to="/">
        {t("not_found.back")}
      </Anchor>
    </Stack>
  );
}
